import React, { useState } from 'react';
import MandantenList, { MandantData } from '../components/MandantenList';
import MandantForm from '../components/MandantForm';
import SuperAdminBenutzerList from '../components/superadmin/SuperAdminBenutzerList';
import SystemPanel from '../components/superadmin/SystemPanel';
import './ManagementPage.css';

interface AuthUser {
  name: string;
  email: string;
  rolle: string;
  tenant_id: number | null;
  tenant_slug: string | null;
  firmenname: string | null;
  primaerfarbe: string | null;
}

interface SuperAdminPageProps {
  authUser: AuthUser;
  authToken: string;
}

type AdminTab = 'mandanten' | 'benutzer' | 'system';

const TABS: Array<{ id: AdminTab; label: string }> = [
  { id: 'mandanten', label: 'Mandanten' },
  { id: 'benutzer', label: 'Benutzer' },
  { id: 'system', label: 'System' },
];

const SuperAdminPage: React.FC<SuperAdminPageProps> = ({ authUser, authToken }) => {
  const [tab, setTab] = useState<AdminTab>('mandanten');
  const [showForm, setShowForm] = useState(false);
  const [editMandant, setEditMandant] = useState<MandantData | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEdit = (mandant: MandantData) => {
    setEditMandant(mandant);
    setShowForm(true);
  };

  const handleNeu = () => {
    setEditMandant(null);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditMandant(null);
    setRefreshKey(k => k + 1);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditMandant(null);
  };

  return (
    <div className="management-page">
      <div className="tab-navigation">
        {TABS.map(t => (
          <button
            key={t.id}
            className={`tab-button ${tab === t.id ? 'active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="tab-content">
        {tab === 'mandanten' && (
          <div style={{ padding: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
              <button
                onClick={handleNeu}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  borderRadius: 0,
                  background: 'var(--gradient-primary)',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                + Neuer Mandant
              </button>
            </div>

            <MandantenList
              authUser={authUser}
              onEdit={handleEdit}
              refreshKey={refreshKey}
            />

            {showForm && (
              <MandantForm
                authUser={authUser}
                mode={editMandant ? 'edit' : 'create'}
                mandant={editMandant ?? undefined}
                onSave={handleSave}
                onClose={handleClose}
              />
            )}
          </div>
        )}

        {tab === 'benutzer' && <SuperAdminBenutzerList authToken={authToken} />}

        {tab === 'system' && <SystemPanel authToken={authToken} />}
      </div>
    </div>
  );
};

export default SuperAdminPage;
